<template>
  <div>
    <div class="action-bar-placeholder"></div>
    <div class="md-example-child md-example-child-action-bar md-example-child-3">
      <md-action-bar :actions="data" @click="onBtnClick">
      <span class="price">
        &yen; {{course.price}} <em>/人次</em>
      </span>
          <!--<md-icon name="question"-->
                   <!--@click="showTip"-->
                   <!--v-if="course.left < course.sessions"></md-icon>-->
      </md-action-bar>
    </div>
  </div>
</template>

<script>
    import {ActionBar, Dialog, Tip, Icon, ActionSheet} from 'mand-mobile'

    export default {
        components: {
            [ActionBar.name]: ActionBar,
            [ActionSheet.name]: ActionSheet,
            [Tip.name]: Tip,
            [Icon.name]: Icon,
        },
        props: ['course'],
        data() {
            return {
                data: [
                    {
                        text: '我要报名',
                        round: true,
                        disabled: this.course.left <= 0,
                    },
                ],
            }
        },
        methods: {
            onBtnClick(event, action) {
                //this.$_showActionSheet();
                this.$router.push({ name: 'enroll', query: { courseId: this.course.id,type:'normal' }})
            },
            goEnroll(id) {
//                if(type == 'normal' && this.course.single_price && this.course.left <= 2) {
//                    this.$toast.failed('下个系列开课时才能报名系列课');
//                    return;
//                }

                this.$router.push({ name: 'enroll', query: { courseId: this.course.id,type:'normal' }})
            },
            showTip() {
                this.$toast.info(`剩余${this.course.left}次活动`);
            },
            $_showActionSheet() {
                const options = [];

                this.course.packages.forEach(item => {
                    options.push({
                        label: `${item.name} (${item.price}元)`,
                        value: item.id,
                    });
                });


                ActionSheet.create({
                    value: true,
//                    title: '报名类型',
                    options:options,
                    cancelText: '取消',
                    onSelected: this.$_selected,
                })
            },
            $_selected(item) {
                this.goEnroll(item.value);
            },
        },
        computed: {
            displayPrice() {
//                if(this.course.can_trial_enroll) {
//                    return this.course.trial_price;
//                } else if(this.course.single_price && this.course.left > 2) {
//                    return this.course.single_price;
//                }

//                return this.$tools.displayPrice(this.course);
            }
        }
    }

</script>

<style lang="stylus" scoped>
  .action-bar-placeholder
    height 300px
  .price
    font-weight 500
    font-size 48px
    color #FF823A
    margin-right 10px
    small
      margin-left 10px
      font-size 32px
      color #858B9C
    em
      font-style normal
      font-size 24px
      color #858B9C
</style>

